import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { Country } from '@/components/countryAutoComplete/countries';

export interface PersonalInfoInterface {
  country?: Country;
}

export const schema = ({ country }: PersonalInfoInterface) => {
  const { t } = useTranslation('signInPersonalInfo');

  return yup.object().shape({
    name: yup
      .string()
      .required(t('create_invalid_name'))
      .min(3, t('create_invalid_name_less_3')),
    surname: yup
      .string()
      .required(t('create_invalid_surname'))
      .min(3, t('create_invalid_surname_less_3')),
    phone: yup
      .string()
      .required(t('create_invalid_phone'))
      .min(
        (country?.length ?? 14) + (country?.maskLength ?? 0),
        t('create_less_min_phone_number', {
          minLength: country?.length ?? 14 + (country?.maskLength ?? 0),
        })
      ),
    countryPhoneCode: yup.string().required(t('create_invalid_country_code')),
    birthDate: yup.string().required(t('create_invalid_birthdate')),
    gender: yup.string().required(t('create_account_invalid_gender')),
    email: yup
      .string()
      .required(t('create_invalid_email'))
      .email(t('create_invalid_email')),
  });
};
